module.exports = __webpack_public_path__ + "img/max-file-configure--zip.8230ad70.svg";